
export const ctas = [
  { text: "Free Profile Review", href: "/profile-evaluation", className: "button is-large w-button" },
  { text: "Pricing", href: "#pricing-plan", className: "button is-large w-button" },
  { text: "Why US?", href: "#why-us", className: "button is-large w-button" },
]
